import { usePageEditorSurfaceMemory } from 'page-editor-ui/copilot/surfaceMemory/usePageEditorSurfaceMemory';
import { jsx as _jsx } from "react/jsx-runtime";
const HIDDEN_STYLE = {
  display: 'none'
};
export default function PageEditorSurfaceMemory() {
  const sections = usePageEditorSurfaceMemory();
  return /*#__PURE__*/_jsx("div", {
    style: HIDDEN_STYLE,
    "aria-hidden": "true",
    children: sections.map(({
      sectionId,
      description
    }) => /*#__PURE__*/_jsx("div", {
      "data-breeze-section-id": sectionId,
      "data-breeze-description": JSON.stringify(description)
    }, sectionId))
  });
}